import { legacy_createStore as createStore, combineReducers } from "redux";
import { authReducer } from "./Auth/reducer";
import { productReducer } from "./Products/reducer";

const rootReducer = combineReducers({
  isAuth: authReducer,
  products: productReducer,
});

export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
